// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-with-extra-props/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { WalletIcon as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetWithExtraPropsMeta: TWidgetMetaInfo = {
  name: 'Widget with Extra Props',
  categories: ['Widget'],
  icon: ComponentIcon,
  noDuplicatedWidgets: true,
  description: 'Sample widget to demonstrate the use of the "extraProps".',
  externalDependencies: [],
}
